/**
 * Traducciones UI ficha propiedad (texto ES exacto → idioma).
 * Complementa crm_campo_labels_i18n; cubre labels, toggles, placeholders y botones.
 */
const FR = {
  // Banner / botones formulario
  "Viendo la ficha en otro idioma (solo lectura). Vuelve a Español para editar. Las traducciones se actualizan al guardar cambios en español.":
    "Affichage en lecture seule dans une autre langue. Revenez en Espagnol pour modifier. Les traductions se mettent à jour lors de l'enregistrement en espagnol.",
  Cancelar: "Annuler",
  "Guardar borrador": "Enregistrer le brouillon",
  "Finalizar ficha": "Finaliser la fiche",
  "Cargando propiedad...": "Chargement du bien…",

  // Cabecera
  Estado: "État",
  Disponible: "Disponible",
  "No disponible": "Non disponible",
  "Disponible de nuevo el": "Disponible à nouveau le",
  Motivo: "Motif",
  "Disponible desde": "Disponible à partir du",
  "Fecha de alta": "Date d'inscription",
  "Última actualización": "Dernière mise à jour",
  Exclusiva: "Exclusivité",
  Publicación: "Publication",
  Precio: "Prix",
  Duración: "Durée",
  Desde: "Du",
  Hasta: "Au",
  Operación: "Opération",
  Venta: "Vente",
  Alquiler: "Location",
  Traspaso: "Cession",
  "Selecciona una operación": "Sélectionnez une opération",
  "Tipo de inmueble": "Type de bien",
  Etiqueta: "Étiquette",
  Referencia: "Référence",
  "Publicar en web": "Publier sur le web",
  "A consultar": "Sur demande",
  Manual: "Manuel",
  Auto: "Auto",

  // Generales — extras
  Planos: "Plans",
  "Inspección ITE": "Inspection ITE",
  "Año fin VPO": "Année fin VPO",
  "V.P.O.": "VPO",
  "Sí": "Oui",
  No: "Non",
  "Selecciona el tipo de inmueble": "Sélectionnez le type de bien",
  Seleccionar: "Sélectionner",
  "Guardando…": "Enregistrement…",
  "Finalizando…": "Finalisation…",
  "✓ Finalizar ficha": "✓ Finaliser la fiche",
  "✓ Actualizar propiedad": "✓ Mettre à jour le bien",
  "✓ Guardar propiedad": "✓ Enregistrer le bien",
  Construidos: "Surface construite",
  Útiles: "Surface utile",
  Terrazas: "Terrasses",
  Jardín: "Jardin",
  Parcela: "Parcelle",
  "Nº Terrazas": "Nº terrasses",
  "Nº Balcones": "Nº balcons",
  "Nº Patios": "Nº patios",
  "Año construcción": "Année de construction",
  "Año reforma": "Année de rénovation",
  Orientación: "Orientation",
  "Calificación energética": "Classe énergétique",
  "En trámite": "En cours",
  Exento: "Exempté",
  "Planos disponibles": "Plans disponibles",
  "Inspección técnica": "Inspection technique",
  Exterior: "Extérieur",
  VPO: "VPO",
  "Cédula habitabilidad": "Certificat d'habitabilité",
  Obs: "Obs.",
  "Obs.": "Obs.",

  // Distribución
  Dormitorios: "Chambres",
  Baños: "Salles de bain",
  Aseos: "Toilettes",
  Salones: "Salons",
  Comedores: "Salles à manger",
  "Plantas del inmueble": "Étages du bien",
  "Plantas del edificio": "Étages de l'immeuble",
  "Altura planta": "Hauteur d'étage",
  Cocinas: "Cuisines",
  "Cocina amueblada": "Cuisine équipée",
  Entradas: "Entrées",
  Armarios: "Placards",
  Amueblado: "Meublé",
  "Detalles...": "Détails…",

  // Económicos
  "Gastos Comunidad": "Charges de copropriété",
  Basuras: "Taxe ordures",
  IBI: "IBI",
  Valoración: "Évaluation",
  Hipoteca: "Hypothèque",
  "Tiene hipoteca": "Hypothèque en cours",
  Observaciones: "Observations",

  // Equipamiento
  Esenciales: "Essentiels",
  "Piscina y Garaje": "Piscine et garage",
  "Zonas comunes": "Parties communes",
  Seguridad: "Sécurité",
  Accesibilidad: "Accessibilité",
  Trastero: "Débarras",
  "Nº trastero": "Nº débarras",
  "Nº garaje": "Nº garage",
  Urbanismo: "Urbanisme",
  "Otros datos de equipamiento": "Autres équipements",

  // Ubicación / localización
  Provincia: "Province",
  Población: "Ville",
  Zona: "Zone",
  Urbanización: "Lotissement",
  "C.P.": "Code postal",
  Dirección: "Adresse",
  "Tipo vía": "Type de voie",
  "Nombre de la vía": "Nom de la voie",
  metros: "mètres",

  // Web
  "Título del Inmueble": "Titre du bien",
  "Descripción Corta": "Description courte",
  "Descripción Larga": "Description longue",
  "Título para publicación web": "Titre pour publication web",
  "Descripción corta...": "Description courte…",
  "Descripción detallada...": "Description détaillée…",
  "Crear Descripción Corta": "Créer description courte",
  "Crear Descripción Larga": "Créer description longue",

  // Internos
  "Precio venta": "Prix de vente",
  "Precio alquiler": "Prix de location",
  "Precio propietario": "Prix propriétaire",
  "Honorarios %": "Honoraires %",
  "Honorarios €": "Honoraires €",
  "Total honorarios": "Total honoraires",
  IVA: "TVA",
  "Observaciones precio": "Observations prix",
  "Agente responsable": "Agent responsable",
  Procedencia: "Origine",
  "Alias interno": "Alias interne",
  Cartel: "Panneau",
  Llaves: "Clés",
  Calificación: "Qualification",
  "Precio negociable": "Prix négociable",
  "Recoger llaves en": "Récupérer les clés à",
  "Info visita": "Info visite",
  "Observaciones internas": "Observations internes",

  // Alquiler
  Fianza: "Caution",
  meses: "mois",
  "Acepta mascotas": "Animaux acceptés",
  "Aval requerido": "Garant requis",
  "Garantía adicional": "Garantie supplémentaire",
  "Duración contrato": "Durée du contrat",
  "Tipo de contrato": "Type de contrat",

  // Multimedia
  Descripción: "Description",
  "Título (opcional)": "Titre (optionnel)",

  // Historial
  "Guarda la propiedad para ver el historial de actividad (leads, citas, ofertas y portales).":
    "Enregistrez le bien pour voir l'historique d'activité (leads, visites, offres et portails).",

  // Distribución — UI extra
  "Plantas / distribución": "Étages / distribution",
  Nombre: "Nom",
  Distribución: "Distribution",
  editando: "en cours d'édition",
  Editar: "Modifier",
  Eliminar: "Supprimer",
  Guardar: "Enregistrer",
  "💾 Guardar cambios": "💾 Enregistrer les modifications",
  "Ej: Vivienda / Planta baja": "Ex. : Logement / Rez-de-chaussée",
  "Ej: salón, cocina, 2 dormitorios…": "Ex. : salon, cuisine, 2 chambres…",
  "Distribución de habitaciones": "Distribution des pièces",
  "Acabados e interiores": "Finitions et intérieurs",
  "Carp. Interior": "Menuiserie int.",
  "Carp. Exterior": "Menuiserie ext.",
  Suelos: "Sols",
  "Tipo...": "Type…",
  "Ej: 3,2 m": "Ex. : 3,2 m",

  // Ubicación extra
  "Línea de playa": "Ligne de plage",
  "1ª Línea de playa": "1re ligne de plage",
  "2ª Línea de playa": "2e ligne de plage",
  "Observaciones...": "Observations…",
  "Distancia al mar": "Distance à la mer",
  "Indicar distancia": "Indiquer la distance",
  Vistas: "Vues",
  "Afectaciones legales": "Affectations légales",
  "No afectado": "Non affecté",
  "Afectación Costas": "Non affecté",
  DPMT: "DPMT",
  "Serv. Tránsito": "Serv. transit",
  "Serv. Protección": "Serv. protection",

  // Registro / nota simple
  Registro: "Registre",
  "Datos Registro": "Données registre",
  "Registro de": "Registre de",
  "Nº Registro": "Nº registre",
  Tomo: "Tome",
  Libro: "Livre",
  Folio: "Folio",
  Finca: "Propriété",
  Inscripción: "Inscription",
  "Ref. Catastral": "Réf. cadastrale",
  "Valor de Referencia": "Valeur de référence",
  "Año Construcción Registro": "Année construction (registre)",
  Título: "Titre",
  Gastos: "Frais",
  "Sup. Catastro": "Surf. cadastre",
  Cargas: "Charges",

  // Publicación web extra
  "Publicación Web": "Publication web",
  "Error al generar": "Erreur lors de la génération",
  "Rellena más datos de la propiedad antes de generar la descripción (tipo, m², dormitorios, etc.)":
    "Renseignez plus de données sur le bien avant de générer la description (type, m², chambres, etc.)",
  "El servidor no respondió a tiempo. Espera unos segundos y vuelve a intentarlo.":
    "Le serveur n'a pas répondu à temps. Attendez quelques secondes et réessayez.",

  // Alquiler extra
  "Fianza y condiciones": "Caution et conditions",
  "Servicios y suministros (quién paga / incluido)": "Services et fournitures (qui paie / inclus)",
  "Incluido en renta": "Inclus dans le loyer",
  "ese gasto ya va dentro del precio de alquiler": "cette charge est déjà incluse dans le loyer",
  "Paga propietario": "Payé par le propriétaire",
  "lo asume el propietario aparte (no está metido en la renta anunciada)":
    "assumé par le propriétaire en plus (non inclus dans le loyer affiché)",
  "Paga inquilino": "Payé par le locataire",
  "el arrendatario paga esa factura": "le locataire paie cette facture",
  "Seguro de alquiler": "Assurance location",
  "Propietario tiene contratado seguro de alquiler": "Le propriétaire a souscrit une assurance location",
  "Si está contratado, la aprobación del arrendatario puede depender de la agencia aseguradora (no solo de la inmobiliaria).":
    "Si elle est souscrite, l'acceptation du locataire peut dépendre de l'assureur (pas seulement de l'agence).",
  "Honorarios de alquiler": "Honoraires de location",
  "Quién paga honorarios": "Qui paie les honoraires",
  "Importe honorarios": "Montant honoraires",
  "Notas de alquiler (fianza, contrato, servicios…)": "Notes location (caution, contrat, services…)",
  Comunidad: "Charges",
  Agua: "Eau",
  Luz: "Électricité",
  Gas: "Gaz",
  Internet: "Internet",
  "LAU (vivienda habitual)": "LAU (résidence principale)",
  Temporal: "Temporaire",
  Habitación: "Chambre",
  Otro: "Autre",
  Inquilino: "Locataire",
  Propietario: "Propriétaire",
  Ambos: "Les deux",
  Ninguno: "Aucun",

  // Propietarios
  "Com.": "Com.",
  Apellidos: "Nom de famille",
  Teléfono: "Téléphone",
  Email: "E-mail",
  Rol: "Rôle",
  "Contacto para comunicación": "Contact pour communication",
  "Editar propietario": "Modifier propriétaire",
  "Eliminar propietario": "Supprimer propriétaire",
  "Editar contacto": "Modifier contact",
  "Nombre, teléfono o email...": "Nom, téléphone ou e-mail…",
  "Contactos asociados": "Contacts associés",
  "Buscar existente:": "Rechercher existant :",
  "— o crear nuevo propietario —": "— ou créer un nouveau propriétaire —",
  "Crear propietario": "Créer propriétaire",
  "— o crear nuevo contacto —": "— ou créer un nouveau contact —",
  "Crear contacto asociado": "Créer contact associé",

  // Equipamiento extra
  "Tipo garaje...": "Type garage…",
  y: "et",
  Plaza: "Place",
  "Garaje / Parking (plazas)": "Garage / Parking (places)",
  Abierto: "Ouvert",
  Cerrado: "Fermé",
  Cubierto: "Couvert",
  Interior: "Intérieur",
  "Agua de riego": "Eau d'arrosage",
  "Luz solar": "Électricité solaire",
  "Pre-inst. luz solar": "Pré-inst. solaire",
  Calefacción: "Chauffage",
  "Aire Acondicionado": "Climatisation",
  Chimenea: "Cheminée",
  Lavadero: "Buanderie",
  "Ducha exterior": "Douche extérieure",
  "Doble cristal": "Double vitrage",
  "Parcela vallada": "Parcelle clôturée",
  "Cocina de verano": "Cuisine d'été",
  "Piscina Privada": "Piscine privée",
  "Piscina Comunitaria": "Piscine collective",
  Ascensor: "Ascenseur",
  "Pozo de agua": "Puits",
  "Zonas Comunes": "Parties communes",
  "Zona Infantil": "Aire de jeux",
  "Zonas Verdes": "Espaces verts",
  "Jardín comunitario": "Jardin collectif",
  "Jardín privado": "Jardin privé",
  Gimnasio: "Salle de sport",
  "Pista Pádel": "Court de padel",
  "Pista Tenis": "Court de tennis",
  Barbacoa: "Barbecue",
  Conserje: "Concierge",
  "Casita aperos": "Abri à outils",
  Alarma: "Alarme",
  "Puerta Blindada": "Porte blindée",
  "Puerta Anti-okupas": "Porte anti-squat",
  "Caja Fuerte": "Coffre-fort",
  Vigilancia: "Surveillance",
  Domótica: "Domotique",
  "Punto Recarga EV": "Point recharge VE",
  "Acceso Discapacitados": "Accès handicapés",
  Adaptado: "Adapté",
  "Salida de Humos": "Sortie fumées",
  "Edif. Uso Viviendas": "Immeuble résidentiel",

  // Historial
  "Resumen de actividad": "Résumé d'activité",
  Leads: "Leads",
  Citas: "Visites",
  Ofertas: "Offres",
  "Interesados en esta ref.": "Intéressés par cette réf.",
  "En agenda vinculadas": "Liées à l'agenda",
  "En el historial": "Dans l'historique",
  "Cargando historial…": "Chargement de l'historique…",
  "Leads interesados": "Leads intéressés",
  "Sin leads con referencia": "Aucun lead avec la référence",
  "de esta propiedad": "de ce bien",
  "Sin citas en agenda vinculadas a esta propiedad": "Aucune visite liée à ce bien",
  "Sin ofertas registradas en el historial": "Aucune offre enregistrée",
  Portales: "Portails",
  "Sin eventos de portales todavía. Los datos detallados se incorporarán con ScrapingAPI.":
    "Pas encore d'événements portails. Les données détaillées arriveront via ScrapingAPI.",
  "Visitas portal": "Visites portail",
  Favoritos: "Favoris",
  "Tiempo medio": "Temps moyen",
  Último: "Dernier",
  "Fecha y hora": "Date et heure",
  Cliente: "Client",
  Consulta: "Demande",
  Agente: "Agent",
  Etapa: "Étape",
  Resultado: "Résultat",
  Detalle: "Détail",
  Portal: "Portail",
  Tipo: "Type",
  cita: "visite",
  "2ª cita": "2e visite",

  // Multimedia
  Multimedia: "Multimédia",
  Fotos: "Photos",
  Vídeos: "Vidéos",
  "Desmarcar todas": "Tout désélectionner",
  "Marcar todas": "Tout sélectionner",
  Descargar: "Télécharger",
  "Descargar fotos": "Télécharger les photos",
  "Preparando…": "Préparation…",
  "Buscar fotos": "Parcourir photos",
  "Buscar vídeos": "Parcourir vidéos",
  "Arrastra fotos aquí o haz click": "Glissez des photos ici ou cliquez",
  "⇅ Reordenar fotos": "⇅ Réordonner les photos",
  "✓ Listo (reordenar)": "✓ Terminé (réordonner)",
  "Regenerar video": "Régénérer la vidéo",
  "Generar video": "Générer la vidéo",
  "Regenerando…": "Régénération…",
  "Generando…": "Génération…",
  "Videos Youtube": "Vidéos YouTube",
  Añadir: "Ajouter",
  "Visita Virtual (URL)": "Visite virtuelle (URL)",
  "Visita 360º (URL)": "Visite 360° (URL)",
  Cerrar: "Fermer",
  "Insertar fotos": "Insérer des photos",

  // Documentación
  "PDF, imágenes, Word, Excel u hojas de cálculo. Arrastra archivos o usa «Adjuntar». Vista previa a la derecha.":
    "PDF, images, Word, Excel ou feuilles de calcul. Glissez des fichiers ou « Joindre ». Aperçu à droite.",
  Documentos: "Documents",
  Adjuntar: "Joindre",
  "No hay documentos. Arrastra aquí encima o usa Adjuntar.":
    "Aucun document. Glissez ici ou utilisez Joindre.",
  Fecha: "Date",
  Principales: "Principaux",
  "Otros documentos…": "Autres documents…",
  "Otros documentos": "Autres documents",
  "Describe el documento…": "Décrivez le document…",
  "Vista previa": "Aperçu",
  Ampliar: "Agrandir",
  "Selecciona un documento": "Sélectionnez un document",
  "No hay vista previa integrada para este formato.":
    "Pas d'aperçu intégré pour ce format.",
  "Abrir / descargar": "Ouvrir / télécharger",
  Documento: "Document",

  // Localización extra
  "Más": "Plus",
  "Cargando...": "Chargement…",
  "Sin zona": "Sans zone",
  "Sin urbanización": "Sans lotissement",
  "✓ Manual": "✓ Manuel",
  "✓ Auto": "✓ Auto",
  "Calle, avenida...": "Rue, avenue…",
  "Nº": "Nº",
  Bloque: "Bloc",
  Escalera: "Escalier",
  Piso: "Étage",
  Puerta: "Porte",
  Coordenadas: "Coordonnées",
  "Obteniendo GPS…": "Obtention GPS…",
  "Actualizando dirección…": "Mise à jour adresse…",
  "📍 Usar mi ubicación": "📍 Utiliser ma position",
  "GPS…": "GPS…",
  "📍 Aquí": "📍 Ici",
  "Obteniendo ubicación GPS…": "Obtention position GPS…",
  "Actualizando dirección desde coordenadas…": "Mise à jour adresse depuis coordonnées…",
  "Obteniendo coordenadas…": "Obtention des coordonnées…",
  "Escribe coordenadas o complétalas desde la dirección":
    "Saisissez les coordonnées ou complétez-les depuis l'adresse",
  "Editable · pin y dirección se sincronizan":
    "Modifiable · épingle et adresse synchronisées",
  "Ubicación en mapa": "Emplacement sur la carte",
  "No hay más poblaciones": "Pas d'autres communes",

  // Datos internos extra
  "Histórico Precios": "Historique des prix",
  "Cargando histórico…": "Chargement historique…",
  alta: "création",
  "Precios y Honorarios": "Prix et honoraires",
  Ocultar: "Masquer",
  "Mostrar datos internos": "Afficher données internes",
  "Sin asignar": "Non assigné",
  "Configura procedencias en Tablas auxiliares.":
    "Configurez les origines dans les tables auxiliaires.",
  "Cartel (puede elegir varias)": "Panneau (choix multiples)",
  Vitalcasa: "Vitalcasa",
  "Otra agencia": "Autre agence",
  "Varias agencias": "Plusieurs agences",
  "🔑 Tenemos llaves": "🔑 Nous avons les clés",
  "Nº llave": "Nº clé",
  "0★ Chollo": "0★ Affaire",
  "1★ Adecuado": "1★ Adéquat",
  "2★ Caro": "2★ Cher",
  "3★ Fuera de mercado": "3★ Hors marché",
  "No sabe": "Ne sait pas",
  "Instrucciones para la visita, acceso, códigos...":
    "Instructions pour la visite, accès, codes…",
  "Notas solo para el equipo (no se publican en la web)...":
    "Notes internes uniquement (non publiées sur le web)…",
  "Notas sobre precio, negociación, condiciones...":
    "Notes sur prix, négociation, conditions…",
  "↕ Calcular desde P.Venta − P.Propietario":
    "↕ Calculer depuis P. vente − P. propriétaire",
  "% Calcular desde P.Venta + % Honorarios":
    "% Calculer depuis P. vente + % honoraires",
  "€/mes": "€/mois",
  "€/año": "€/an",
};

const EN = {
  Estado: "Status",
  Disponible: "Available",
  "No disponible": "Unavailable",
  "Disponible desde": "Available from",
  "Fecha de alta": "Listing date",
  Exclusiva: "Exclusive",
  Publicación: "Publication",
  Precio: "Price",
  Operación: "Transaction",
  Venta: "Sale",
  Alquiler: "Rent",
  "Tipo de inmueble": "Property type",
  Referencia: "Reference",
  "A consultar": "Price on request",
  Construidos: "Built area",
  Útiles: "Usable area",
  Terrazas: "Terraces",
  Jardín: "Garden",
  Parcela: "Plot",
  Dormitorios: "Bedrooms",
  Baños: "Bathrooms",
  Cancelar: "Cancel",
  "Finalizar ficha": "Finish record",
  "Guardar borrador": "Save draft",
};

const DE = {
  Estado: "Status",
  Disponible: "Verfügbar",
  "No disponible": "Nicht verfügbar",
  Operación: "Transaktion",
  Venta: "Verkauf",
  Alquiler: "Miete",
  "Tipo de inmueble": "Immobilientyp",
  Cancelar: "Abbrechen",
  "Finalizar ficha": "Datensatz abschließen",
};

const CA = {
  Estado: "Estat",
  Disponible: "Disponible",
  Operación: "Operació",
  Venta: "Venda",
  Alquiler: "Lloguer",
  Cancelar: "Cancel·lar",
  "Finalizar ficha": "Finalitzar fitxa",
};

const MAPS = { fr: FR, en: EN, de: DE, ca: CA };

export function translateUiString(lang, esText, esTextMap = null) {
  if (!lang || lang === "es" || esText == null) return esText;
  const s = String(esText);
  if (esTextMap && esTextMap[s]) return esTextMap[s];
  const map = MAPS[lang];
  if (map && map[s]) return map[s];
  return s;
}
